<template lang="pug">
#mobile-menu-overlay.mobile-menu-overlay
  .mobile-menu-overlay__inner
    .mobile-menu-overlay__header
      .container-fluid
        .row.align-items-center
          .col-md-6.col-8
            //- logo
            .logo
              router-link(:to="{name:'Home'}")
                img.img-fluid(src='assets/images/logo/logo-dark.png' alt='')
          .col-md-6.col-4
            //- mobile menu content
            .mobile-menu-content.text-right
              span#mobile-menu-close-trigger.mobile-navigation-close-icon
    .mobile-menu-overlay__body
      nav.offcanvas-navigation
        ul
          li
            router-link(:to="{name:'Home'}") Inicio
          li
            router-link(:to="{name:'Home'}") Quienes somos
          li
            router-link(:to="{name:'Home'}") Formaci&oacute;n acad&eacute;mica
          li
            router-link(:to="{name:'Home'}") Suscripci&oacute;n
          li
            router-link(:to="{name:'BlogList'}") Noticias
          li
            router-link(:to="{name:'Contact'}") Contacto

</template>

<script type="text/javascript">
export default {
  name: "TopbarMobile",
  data() {
    return {};
  },
};
</script>
